import axios from "axios";
import config from "../config";

const parseUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null") || {};
  } catch {
    return {};
  }
};

const isBackendRequest = (url = "") => {
  if (!url) return true;

  const safeUrl = String(url);
  const isAbsolute = /^https?:\/\//i.test(safeUrl);
  if (!isAbsolute) return true;

  const apiBase = config.API_URL || "";
  const blApiBase = config.BL_API_URL || "";

  return (apiBase && safeUrl.startsWith(apiBase)) || (blApiBase && safeUrl.startsWith(blApiBase));
};

axios.interceptors.request.use(
  (request) => {
    if (!isBackendRequest(request?.url)) {
      return request;
    }

    const user = parseUser();
    const appUserId =
      user?.appUserId ||
      user?.clientId ||
      user?.id ||
      localStorage.getItem("appUserId") ||
      localStorage.getItem("clientId");

    const companyId = user?.companyId || localStorage.getItem("companyId");

    request.headers = request.headers || {};

    if (appUserId !== null && appUserId !== undefined && appUserId !== "" && !request.headers.appUserId) {
      request.headers.appUserId = String(appUserId);
    }

    if (companyId !== null && companyId !== undefined && companyId !== "" && !request.headers.companyId) {
      request.headers.companyId = String(companyId);
    }

    return request;
  },
  (error) => Promise.reject(error)
);
